import React, { useState } from "react";
import { Button, Layout, Spin, Modal, Select, Table } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import Cookies from "js-cookie";
import axios from "axios";
import * as XLSX from "xlsx";
import { Redirect, Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import './PayrollHours.css';
const { Header, Content } = Layout;

const PayrollHours = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");
    const [antdSpinner, setAntdSpinner] = useState(false)

    const downloadHoursExcel = async () => {
        try {
            setAntdSpinner(true)
            const url = `${process.env.REACT_APP_BASE_URL}PreviewReview/Get_AuditHours_data`
            const headers = { headers: { "Content-Type": "Application/json", Authorization: `Bearer ${jwtToken}` } }
            const response = await axios.get(url, headers)
            let temp = response.data;
            handleHrsData(temp)
        }
        catch {
            setAntdSpinner(false)
        }
    }
    const handleHrsData = (props) => {
        const listData = props
        let loopedList = []
        loopedList.length = 0;
        let len = listData.length;
        for (let i = 0; i < len; i++) {
            loopedList.push({
                Client_Name: listData[i].client_Name,
                Portal_Name: listData[i].portal_Name,
                RT_Total: listData[i].dump_RtTotal,
                OT_Total: listData[i].dump_OtTotal,
                DT_Total: listData[i].dump_DtTotal,
                Masterfile_RT: listData[i].masterFile_RT,
                Masterfile_OT: listData[i].masterFile_OT,
                Masterfile_DT: listData[i].masterFile_DT
            })
        }
        handleHoursExcel(loopedList)
    }
    const handleHoursExcel = (props) => {
        const listData = props;
        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(listData);

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, "PayrollHoursAudit.xlsx");
        setAntdSpinner(false)
    }
    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
    return (<>
        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="payrollhrs-header-class"><Navbar /></Header>
                <Content className="payrollhrs-content">
                    <div className="payrollhrs-allpages-class">
                        <Button className="payrollhrs-currentpage-button">Payroll Hours Audit</Button>
                        <Link to="/preview"><Button className="payrollhrs-page-button">Preview/Review</Button></Link>
                        <Link to="/payrollchecklist"> <Button className="payrollhrs-page-button">Payroll Checklist</Button></Link>
                        <Link to="/audit"><Button className="payrollhrs-page-button">Selected Crawling</Button></Link>
                        {/* <Link to="/activitylog"><Button className="payrollhrs-page-button">Activity Log</Button></Link> */}
                    </div>
                    <div className="payrollhrs-table-class">
                        <Button className="downloadhrs-btn" onClick={downloadHoursExcel}>Download Hours Audit</Button>
                        {antdSpinner && <div className="spin-icon-class">
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} />} />
                        </div>}
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)
}

export default PayrollHours;